import { useKeycloak } from "@react-keycloak/web";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RecommTable from './RecommTable';
import TextOrMdash from './TextOrMdash';
import DisplayFoto from './DisplayFoto';
import DeEscapeTxt from "./DeEscapeTxt";

function PrevDoplnek(props: any) {
    const { keycloak, initialized } = useKeycloak();
    const navigate = useNavigate();
    const viditelnost = useSelector((state: any) => state.miscDicts.viditelnost);
    //console.log("PrevDoplnek.tsx - viditelnost from Redux")
    //console.log(viditelnost)
    const klasifikace = useSelector((state: any) => state.miscDicts.klasifikace);
    return (
        <tr className='itemRow' key={props.doplnek.id} onClick={() => navigate('/doplnky/doplnek/' + props.doplnek.id)}>
            <td><TextOrMdash text={DeEscapeTxt(props.doplnek.kod)}/></td>
            <td><TextOrMdash text={DeEscapeTxt(props.doplnek.nazev)}/></td>
            {(typeof (props.doplnek.foto) !== 'undefined' && props.doplnek.foto != null)
                ? <td width={"300px"}><div>{props.doplnek.foto.map((foto: any)=> <DisplayFoto key={foto.fotoId} foto={foto}/>)}</div></td>
                : <td>&mdash;</td>}
            <td>{(typeof (props.doplnek.doplnkyPouziti) !== 'undefined' && props.doplnek.doplnkyPouziti != null)
                    ? <RecommTable recommendations={props.doplnek.doplnkyPouziti} />
                    : <div>&mdash;</div>}
            </td>
            <td>{(typeof (klasifikace) !== 'undefined' && klasifikace != null && klasifikace.length != 0)
                    ? <TextOrMdash text={klasifikace.find((klasif: any)=>klasif.key===props.doplnek.klasifikace).value} />
                    : <div>&mdash;</div>}</td>
            <td><TextOrMdash text={DeEscapeTxt(props.doplnek.popis)}/></td>
            <td><TextOrMdash text={DeEscapeTxt(props.doplnek.modifikace)}/></td>
            <td><TextOrMdash text={DeEscapeTxt(props.doplnek.poznamka)}/></td>
            <td><TextOrMdash text={DeEscapeTxt(props.doplnek.dostupnost)}/></td>
            <td><TextOrMdash text={props.doplnek.datumeditace}/></td>
            {keycloak.authenticated && (
            <td>{(typeof (viditelnost) !== 'undefined' && viditelnost != null && viditelnost.length != 0)
                ? <TextOrMdash text={viditelnost.find((vid: any)=>vid.key===props.doplnek.viditelnost).value} />
                : <div>&mdash;</div>}</td>
             )}
        </tr>)
}
export default PrevDoplnek